import { render, staticRenderFns } from "./medicion-prevalencia-grafica.vue?vue&type=template&id=420ee0f3&scoped=true&"
import script from "./medicion-prevalencia-grafica.vue?vue&type=script&lang=js&"
export * from "./medicion-prevalencia-grafica.vue?vue&type=script&lang=js&"
import style0 from "./medicion-prevalencia-grafica.vue?vue&type=style&index=0&id=420ee0f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ee0f3",
  null
  
)

export default component.exports